<template>
  <v-dialog content-class="dialog-signature" v-model="open" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
    <div class="header">
      <div v-if="signing_method !== 'link' ? (!signature_hash || signed_terms) : true" class="close">
        <v-icon @click="closeDialog()" color="white">mdi-close</v-icon>
      </div>
      <h2>Assinatura eletrônica</h2>
      <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
        {{ tab_description[tab] ? tab_description[tab] : (signing_method === 'in_person' ? 'Assinatura presencial': 'Assinatura via link') }}
      </div>
    </div>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <div style="margin-top: 100px; padding: 20px">
          <b>Nome de quem vai assinar:</b> <small style="color: red;">(obrigatório)</small>
          <v-text-field v-model="signing_name" :disabled="loading_types" class="mt-2 mb-3" clearable hide-details filled></v-text-field>
          <small>Caso o assinante seja uma empresa, informe os dados da pessoa responsável na entrega do veículo.</small>
          <div v-if="signing_type === 'client'">
            <br/>
            <b>WhatsApp de quem vai assinar:</b> <small style="color: red;">(obrigatório)</small>
            <v-text-field v-model="signing_phone" :disabled="loading_types" class="mt-2 mb-3" clearable hide-details filled></v-text-field>
            <small>Será utilizado para receber o código de confirmação para assinatura.</small>
            <br/>
            <br/>
            <b>E-mail de quem vai assinar:</b>
            <v-text-field v-model="signing_email" :disabled="loading_types" class="mt-2 mb-3" clearable hide-details filled></v-text-field>
            <small>Para que o assinante receba e possa consultar o documento assinado, promovendo transparência e segurança jurídica.</small>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item style="padding: 120px 20px;">
        <div>
          <b>Selecione o método de assinatura:</b>
          <v-radio-group v-model="signing_method" row hide-details class="mb-6 mt-1">
            <v-radio label="REMOTO (LINK)" value="link"></v-radio>
            <v-radio label="PRESENCIAL" value="in_person"></v-radio>
          </v-radio-group>
        </div>
        <div class="signature-types">
          <b class="pb-2">Selecione os termos para assinatura:</b><br>
          <small>(Clique sobre o titulo, você pode selecionar vários)</small>
          <v-alert v-if="listSignatureTypes.length === 0" class="mt-3" color="#48B38B" dark border="left">
            Acesse o painel <b>do computador</b> para configurar os termos de assinatura.
          </v-alert>
          <div v-if="listSignatureTypes">
            <div
              v-for="signatureType in listSignatureTypes"
              :key="signatureType.id"
              class="signature-type"
              :class="{ selected: selected_signature_type.some(item => item.id === signatureType.id) }"
            >
              <div @click="clickType(signatureType)" class="st-title">{{ signatureType.title }}</div>
              <div @click="clickType(signatureType)" class="st-description">{{ replaceDescription(signatureType, 250) }}</div>
              <div v-if="selected_signature_type.some(item => item.id === signatureType.id) && signatureType.description.includes('{{ TEXTO_LIVRE }}')" style="padding: 10px;">
                <b>Texto complementar (opcional):</b>
                <v-textarea v-model="signatureType.signing_additional_text" class="mb-6 mt-3" hide-details filled></v-textarea>
              </div>
            </div>
          </div>
          <v-skeleton-loader v-else class="mt-2" height="200px" type="image"></v-skeleton-loader>
        </div>
      </v-tab-item>

      <div v-if="signing_method !== 'link'">
        <v-tab-item>
          <div style="margin-top: 95px; padding: 10px">
            <div class="selected-signature-pdf mt-2">
              <iframe v-if="url_os" :src="url_os" frameborder="0" style="width: 100%; height: 600px"></iframe>
              <div style="font-size: 12px; text-align: center;">
                (Navegue no Relatório de Serviço para conferir todos os detalhes)
              </div>
            </div>

          </div>
        </v-tab-item>

        <v-tab-item v-for="t in selected_signature_type" :key="'dynamic-' + t.id">
          <div class="selected-signature">
            <div class="selected-signature-title">{{ t.title }}</div>
            <div class="selected-signature-term" v-html="replaceDescription(t, false)"></div>
          </div>
        </v-tab-item>

        <v-tab-item v-if="(tab+1) === all_steps" style="background-color: #F5F5F5; padding-bottom: 100px;">
          <div v-if="!signed_terms">
            <div style="margin-top: 100px; padding: 20px; background-color: #fff;">
              <small>Ao <b>concluir</b>, você estará assinando eletronicamente o Relatório de Serviço e os termos anexados, confirmando sua concordância com o que foi estabelecido:</small> <br/>
              <ul class="mt-3" style="font-size: 14px;">
                <li v-for="signature in selected_signature_type" :key="signature.id">
                  {{ signature.title }};
                </li>
              </ul>
            </div>
            <div style="margin-top: 20px; padding: 20px; background-color: #fff;">
              <b>Escolha uma opção abaixo para confirmar sua assinaura eletrônica:</b><br/>
              <div @click="selectConfirmCodeType('whatsapp')" style="border-radius: 6px; padding: 10px; overflow: hidden; margin-top: 15px; border: 4px solid #42a27f; background-color: #48B48D; color: #fff;">
                <div style="float: left; width: 46px; padding: 8px;">
                  <v-icon dark>mdi-whatsapp</v-icon>
                </div>
                <div style="float: left; width: calc(100% - 46px); line-height: 20px;">
                  <div>WhatsApp</div>
                  <small>Você receberá uma mensagem de confirmação</small>
                </div>
              </div>
              <div @click="selectConfirmCodeType('sms')" style="border: 2px solid #eee; border-radius: 6px; padding: 10px; overflow: hidden; margin-top: 15px;">
                <div style="float: left; width: 46px; padding: 8px;">
                  <v-icon>mdi-chat-outline</v-icon>
                </div>
                <div style="float: left; width: calc(100% - 46px); line-height: 20px;">
                  <div>SMS</div>
                  <small>Você receberá um SMS de confirmação</small>
                </div>
              </div>
              <div v-if="signing_email" @click="selectConfirmCodeType('email')" style="border: 2px solid #eee; border-radius: 6px; padding: 10px; overflow: hidden; margin-top: 15px;">
                <div style="float: left; width: 46px; padding: 8px;">
                  <v-icon>mdi-email-outline</v-icon>
                </div>
                <div style="float: left; width: calc(100% - 46px); line-height: 20px;">
                  <div>E-mail</div>
                  <small>Você receberá uma e-mail de confirmação</small>
                </div>
              </div>
              <div style="text-align: center; padding-top: 18px; font-size: 12px;">
                (Confirme sua assinatura antes de fechar o aplicativo)
              </div>
            </div>
            <div style="margin-top: 20px; padding: 20px; background-color: #fff;">
              <b>Prévia da assinatura eletrônica:</b>
              <div v-if="dialog_change_signature_image.image.base64">
                <img :src="dialog_change_signature_image.image.base64" class="mt-4" style="max-width: 100%; border: 2px solid #eee; border-radius: 6px;">
              </div>
              <div
                v-else
                ref="capture"
                class="signature-area mt-4"
              >
                <div
                  class="signature"
                  :style="determineFontSize(signing_name)"
                >
                  {{ signing_name }}
                </div>
                <small style="font-size: 11px;">{{ formatPhone(signing_phone) }}{{ signing_email ? ' | ' + signing_email : '' }}</small>
              </div>
              <v-btn outlined @click="dialog_change_signature_image.open = true" color="#48B48D" elevation="0" style="margin-top: 14px; width: -webkit-fill-available;">
                Desenhar assinatura
              </v-btn>
            </div>
          </div>

          <div v-else style="margin-top: 100px; padding: 20px 20px 0px 20px; background-color: #fff;">
            <img
              :key="tab"
              :src="`${require('@/assets/check_animated.svg')}?v=${Math.random()}`"
              height="230"
              style="margin: 0 auto; display: block"
            />
            <div style="text-align: center; width: 100%">
              <h2 style="margin: 20px 0px">PRONTO, TUDO CERTO!</h2>
            </div>
            <div style="margin: 10px 0px; font-size: 13px; text-align: center;">
              O arquivo PDF da assinatura gerado e assinado ficará disponível no link após o processamento finalizar. <b>Você já pode devolver o aparelho para quem está realizando seu atendimento</b>.
            </div>
            <div class="footer-checkmotors pb-4 pt-2">{{ new Date().getFullYear() }} © <b>CheckMotors v3.7.41</b></div>
          </div>
        </v-tab-item>
      </div>

      <div v-else>
        <v-tab-item style="background-color: #F5F5F5; padding-bottom: 100px;">
          <div style="margin-top: 100px; padding: 20px; background-color: #fff;">
            <small>Você deverá enviar o link do serviço para o número <b>{{ formatPhone(signing_phone) }}</b> para assinar o relatório de serviço completo: Termos de assinatura selecionados, checklists, fotos e vídeos.</small>
          </div>
          <div style="margin-top: 20px; padding: 20px; background-color: #fff;">
            <b>Termos selecionados para assinatura:</b>
            <ul class="mt-3">
              <li v-for="signature in selected_signature_type" :key="signature.id">
                {{ signature.title }};
              </li>
            </ul>
          </div>
          <div style="margin-top: 20px; padding: 20px; background-color: #fff;">
            <b>Prévia da assinatura que será anexada:</b>
            <div
              ref="capture"
              class="signature-area mt-4"
            >
              <div
                class="signature"
                :style="determineFontSize(signing_name)"
              >
                {{ signing_name }}
              </div>
              <small style="font-size: 11px;">{{ formatPhone(signing_phone) }}{{ signing_email ? ' | ' + signing_email : '' }}</small>
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div style="margin-top: 100px; padding: 20px 20px 0px 20px">
            <img
              :key="tab"
              :src="`${require('@/assets/check_animated.svg')}?v=${Math.random()}`"
              height="230"
              style="margin: 0 auto; display: block"
            />
            <div style="text-align: center; width: 100%">
              <h2 style="margin: 20px 0px">PRONTO, TUDO CERTO!</h2>
            </div>
            <div style="margin: 10px 0px; font-size: 12px">
              <b style="color: red;">Importante: </b>Agora você precisa clicar abaixo para encaminhar o link com os termos para assinatura no WhatsApp do cliente, assim ele pode assinar de forma remota.
            </div>
            <div class="my-5" style="overflow: hidden">
              <v-btn @click="shareOS()" color="#48B38B" outlined block> <v-icon class="mr-2">mdi-whatsapp</v-icon> Enviar no WhatsApp </v-btn>
            </div>
            <div class="footer-checkmotors mb-4 4">{{ new Date().getFullYear() }} © <b>CheckMotors v3.7.41</b></div>
          </div>
        </v-tab-item>
      </div>
    </v-tabs-items>

    <div v-if="(signing_method === 'link' && tab + 1 <= all_steps) || (signing_method !== 'link' && !signed_terms)" :key="tab" class="signature-stepper-footer">
      <v-btn
        @click="returnStep()"
        :dark="tab !== 0 && !(signing_method !== 'link' && tab === 2)"
        elevation="0"
        :disabled="tab === 0 || (signing_method !== 'link' && tab === 2)"
        color="#6d6d6d"
        width="75px"
        height="50px"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <div class="step-counter">
        ETAPA <b>{{ tab + 1 }}</b> DE <b>{{ all_steps }}</b>
      </div>

      <v-btn
        :key="tab"
        @click="nextStep()"
        :disabled="signing_method === 'link' ? loading_types : (loading_types || tab + 1 === all_steps)"
        :dark="signing_method === 'link' ? !loading_types : !(loading_types || tab + 1 === all_steps)"
        elevation="0"
        color="primary"
        width="104px"
        height="50px"
      >
        Próxima
      </v-btn>
    </div>

    <v-dialog v-if="signing_method === 'link'" v-model="loading_generating_signature" max-width="240" persistent>
      <div style="text-align: center; padding-bottom: 20px; background-color: #fff;">
        <img :src="require('@/assets/timer.gif')" height="120" style="filter: grayscale(1); opacity: 0.6; margin-top: 20px;"/><br/>
        <small class="pb-2">Não feche o aplicativo...</small>
      </div>
    </v-dialog>

    <v-dialog v-model="dialog_to_client.open" max-width="400" :persistent="loading_generating_signature">
      <v-card>
        <div style="padding: 20px; text-align: center; font-size: 22px; font-weight: bold; color: #3e4e63;">Assinatura presencial</div>
        <v-card-text style="padding-top: 20px">
          <div style="text-align: center;"><img :src="require('@/assets/to-user-phone.png')" height="116"/></div>
          <div style="text-align: center; padding-top: 25px; padding-bottom: 20px;"><b>Agora é com o assinante!</b> Entregue o celular para que ele leia os termos e realize a assinatura eletrônica.</div>
          <v-btn
            @click="dialog_to_client.open = false"
            :loading="loading_generating_signature"
            block
            elevation="0"
            color="primary"
            dark
          >
            PROSSEGUIR
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirm_code.open" max-width="400" persistent>
      <v-card>
        <div style="padding: 20px; text-align: center; color: #3e4e63;">
          <b style="font-size: 22px;">Código de verificação</b><br/>
          <small>Digite abaixo o código de 6 digitos que foi enviado para <b>{{ dialog_confirm_code.type_notification === 'email' ? signing_email : formatPhone(signing_phone) }}</b> através do <b>{{ dialog_confirm_code.type_notification ? dialog_confirm_code.type_notification.toUpperCase() : '' }}</b>.</small>
        </div>
        <v-card-text>
           <v-otp-input
            v-model="dialog_confirm_code.code"
            :disabled="loading_confirmation"
            length="6"
            color="#314e5d"
            type="number"
          ></v-otp-input>
          <v-btn :loading="loading_confirmation" @click="generateHash()" block large depressed color="#48c295" elevation="0" class="mt-4 white--text">
            CONFIRMAR E ASSINAR
          </v-btn>
          <div v-if="!loading_confirmation" style="text-align: center; margin-top: 10px;">
            <div style="margin-bottom: 6px;">
              ou
            </div>
            <b @click="dialog_confirm_code.open = false">FECHAR JANELA</b>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="dialog_change_signature_image.open" persistent>
      <div>
        <div class="signature-pad">
          <div style="padding-bottom: 8px; padding-left: 10px;">
            Desenhe sua assintura na área abaixo:
          </div>
          <div class="pad-content">
            <VueSignaturePad
              v-if="dialog_change_signature_image.pad"
              width="100%"
              height="200px"
              ref="signaturePad"
            />
          </div>
          <div class="pad-bottom">
            <v-btn @click="dialog_change_signature_image.open = false" color="#d1d1d1" depressed large>
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn @click="clearSignature()" color="#d1d1d1" depressed large>
              Limpar
            </v-btn>
            <v-btn
              @click="updateSignatureImage()"
              style="width: 50%"
              color="#48B38B"
              dark
              depressed
              large
            >
              Concluir
            </v-btn>
          </div>
        </div>
      </div>
    </v-bottom-sheet>

  </v-dialog>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import html2canvas from 'html2canvas'
import UserTempTokenService from '@/services/api/userTempToken';

export default {
  props: {
    open: Boolean
  },
  data: () => ({
    tab: 0,
    all_steps: 3,
    tab_description: [
      'Especifique os dados do assinante',
      'Selecione um ou mais termos',
      'Verifique o checklist online'
    ],
    signed_terms: false,
    signing_method: 'link',
    signing_type: 'client',
    signing_name: '',
    signing_email: '',
    signing_phone: '',
    signature_image: null,
    signature_hash: null,
    signature_types: [],
    signature_created: null,
    selected_signature_type: [],
    copy_alert: false,
    organization_url: null,
    loading_types: false,
    loading_confirmation: false,
    url_os: null,
    dialog_to_client: {
      open: false,
    },
    dialog_confirm_code: {
      open: false,
      type_notification: '',
      code: null
    },
    dialog_change_signature_image: {
      open: false,
      pad: false,
      image: {
        base64: null,
        file: null
      }
    },
    loading_generating_signature: false
  }),
  beforeDestroy() {
    if (this.signaturePadTimer) {
      clearTimeout(this.signaturePadTimer);
    }
    if (this.signaturePadResizeTimer) {
      clearTimeout(this.signaturePadResizeTimer);
    }
  },
  mounted() {
    this.getSignatureTypes();
    this.signing_name = this.service_order.client ? this.service_order.client.name : null;
    this.signing_email = this.service_order.client ? this.service_order.client.email : null;
    this.signing_phone = this.service_order.client ? this.service_order.client.phone.replace(/\D/g, '') : null;
    this.organization_url = this.getReportDomainUrl();
    this.getUrlOs();
  },
  computed: {
    listSignatureTypes() {
      const self = this;
      return self.signature_types.filter((signature) => signature.type === self.signing_type);
    },
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    user_logged() {
      return this.$store.getters['Auth/user'];
    },
  },
  methods: {
    getOrganizationParameter(code) {
      const user = this.$store.getters['Auth/user'];
      const search = user.organization.organization_parameters.find((parameter) => parameter.code === code);
      return search ? search.value : false;
    },
    getReportDomainUrl() {
      const newReportActive = this.getOrganizationParameter('NEW_REPORT_ACTIVE');
      const isNewReportActive = String(newReportActive).toUpperCase() === 'TRUE';

      if (isNewReportActive) {
        const newReportDomainUrl = this.getOrganizationParameter('NEW_REPORT_ORG_DOMAIN_URL');
        if (newReportDomainUrl) {
          return newReportDomainUrl;
        }
      }

      return this.getOrganizationParameter('ORGANIZATION_DOMAIN_URL');
    },
    getReportPathPrefix() {
      const newReportActive = this.getOrganizationParameter('NEW_REPORT_ACTIVE');
      return String(newReportActive).toUpperCase() === 'TRUE' ? 'servico' : 'os';
    },
    isNewReportActive() {
      const newReportActive = this.getOrganizationParameter('NEW_REPORT_ACTIVE');
      return newReportActive === 'TRUE' || newReportActive === 'true' || newReportActive === true;
    },
    extractOrgSlugFromUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }

      const sanitizedUrl = url.replace(/\/+$/, '');
      const parts = sanitizedUrl.split('/');
      return parts[parts.length - 1] || '';
    },
    closeDialog() {
      this.$emit('close-dialog');
    },
    scrollToTop() {
      const content = document.querySelector('.dialog-signature');
      if (content) {
        content.scrollTop = 0;
      }
    },
    getSignatureTypes() {
      const self = this;
      self.loading_types = true;
      self.$http.get('/service_order/signature/types').then((response) => {
        self.signature_types = response.data;
        self.loading_types = false;
      });
    },
    replaceDescription(selectedSignatureType, limit) {
      if (selectedSignatureType) {
        const dataAtual = new Date().toLocaleString('pt-BR');
        let descricaoFormatada = selectedSignatureType.description.replace('{{ DATA_HORA }}', dataAtual);

        if (selectedSignatureType.signing_additional_text) {
          descricaoFormatada = descricaoFormatada.replace('{{ TEXTO_LIVRE }}', selectedSignatureType.signing_additional_text);
        }

        descricaoFormatada = descricaoFormatada.replace('{{ OS_NUMERO }}', this.service_order.number);

        if (this.service_order.client) {
          descricaoFormatada = descricaoFormatada.replace('{{ NOME_CLIENTE }}', this.service_order.client.name);
          descricaoFormatada = descricaoFormatada.replace('{{ CPF_CLIENTE }}', this.service_order.client.cpf_cnpj);
        }

        if (this.service_order.vehicle) {
          if (
            this.service_order.vehicle.vehicle_brand &&
            this.service_order.vehicle &&
            this.service_order.vehicle.vehicle_brand.description &&
            this.service_order.vehicle.description
          ) {
            descricaoFormatada = descricaoFormatada.replace(
              '{{ VEICULO_MODELO }}',
              `${this.service_order.vehicle.vehicle_brand.description} ${this.service_order.vehicle.description}`
            );
          }
          descricaoFormatada = descricaoFormatada.replace(
            '{{ VEICULO_ANO }}',
            `${this.service_order.vehicle.year}/${this.service_order.vehicle.year_model}`
          );
          descricaoFormatada = descricaoFormatada.replace('{{ VEICULO_PLACA }}', this.service_order.vehicle.vehicle_plate);
        }

        return !limit ? descricaoFormatada.replace(/\n/g, '<br>') : `${descricaoFormatada.substring(0, limit)}...`;
      }

      return null;
    },
    clickType(type) {
      const exists = this.selected_signature_type.some(item => item.id === type.id);
      if (exists) {
        this.all_steps = this.all_steps <= 3 ? 3 : this.all_steps -1 ;
        this.selected_signature_type = this.selected_signature_type.filter(item => item.id !== type.id);
      } else {
        if (this.signing_method !== 'link') {
          this.all_steps += 1;
        }
        this.selected_signature_type.push(type);
      }
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    updateSignatureImage() {
      const { data } = this.$refs.signaturePad.saveSignature();
      const blob = this.dataURItoBlob(data);
      this.dialog_change_signature_image.image.base64 = data;
      this.dialog_change_signature_image.image.file = new File([blob], 'assinatura.png', { type: 'image/png' });
      this.dialog_change_signature_image.open = false;
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    },
    async saveSignature() {
      const self = this;
      self.loading_generating_signature = true;

      try {
        const parsedTerms = self.selected_signature_type.map(signature => ({
          id: signature.id,
          description: self.replaceDescription(signature, false),
        }));

        self.$http
          .post(`/service_order/${self.service_order.id}/signature/create`, {
            signing_name: self.signing_name,
            signing_phone: self.signing_phone.replace(/\D/g, ''),
            signing_email: self.signing_email,
            signing_method: self.signing_method,
            service_order_signature_type_parsed_terms: JSON.stringify(parsedTerms)
          })
          .then((r) => {
            self.signature_hash = r.data.hash;
            self.$store.dispatch('ServiceOrder/updateSignature', r.data.created_terms);
            self.loading_generating_signature = false;
            if (self.signing_method !== 'in_person') {
              self.tab += 1;
            } else {
              self.logViewTerm('access_report');
            }
          })
          .catch(() => {
            self.loading_generating_signature = false;
          });

      } catch (error) {
        console.error('Erro ao iniciar assinatura:', error);
        self.loading_generating_signature = false;
      }
    },
    async generateHash() {
      const self = this;
      self.loading_confirmation = true;

      try {
        let fileSignature = null;

        if (this.dialog_change_signature_image.image.file) {
          fileSignature = this.dialog_change_signature_image.image.file;
        } else {
          const canvas = await html2canvas(this.$refs.capture);
          const signatureImage = canvas.toDataURL('image/png');
          const blob = self.dataURItoBlob(signatureImage);
          fileSignature = new File([blob], 'assinatura.png', { type: 'image/png' });
        }

        const formData = new FormData();
        formData.append('file', fileSignature);
        formData.append('phone', self.signing_phone.replace(/\D/g, ''));
        formData.append('code_sms', self.dialog_confirm_code.code);
        formData.append('type', self.dialog_confirm_code.type_notification);
        formData.append('signature_hash', self.signature_hash);
        formData.append('service_order_hash', self.service_order.hash);

        await self.$http.post(
          `/service_order/${self.service_order.id}/signature/hash`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            timeout: 1000 * 240
          }
        );

        self.signed_terms = true;
        self.dialog_confirm_code = {
          open: false,
          type_notification: '',
          code: null
        };
      } catch (error) {
        console.error('Erro ao confirmar assinatura:', error);
      } finally {
        self.loading_confirmation = false;
      }
    },
    shareOS() {
      if (this.organization_url) {
        window.open(`whatsapp://send?text=${this.organization_url}/${this.getReportPathPrefix()}/${this.service_order.hash?.replaceAll('-', '')}`);
      }
    },
    returnStep() {
      this.tab -= 1;
    },
    nextStep() {
      if (this.loading_types) return
      if (this.tab === 0) {
        if (this.signing_type.length > 3) {
          if (this.signing_phone && /^(\(?\d{2}\)?\s?)?(\d{4,5})[-\s]?(\d{4})$/.test(this.signing_phone)) {
            this.tab = 1;
          } else {
            this.$toast.error('Especifique um whatsapp válido do assinante.', {
              position: 'bottom-center',
            });
          }
        } else {
          this.$toast.error('Especifique o nome do assinante.', {
            position: 'bottom-center',
          });
        }
      } else if (this.tab === 1) {
        if (this.selected_signature_type.length > 0) {
          this.tab += 1;
          if (this.signing_method !== 'link') {
            this.showToClientModal();
          }
        } else {
          this.$toast.error('Selecione ao menos um termo para prosseguir.', {
              position: 'bottom-center',
            });
        }
      } else if (this.signing_method === 'link') {
        if (this.tab === 2) {
          this.saveSignature();
        }
      } else {
        this.tab += 1;
      }
    },
    async getUrlOs() {
      if (this.isNewReportActive()) {
        const response = await UserTempTokenService.createByOsHash({
          os_hash: this.service_order.hash
        });
        const newReportDomain = this.getOrganizationParameter('NEW_REPORT_ORG_DOMAIN_URL');
        const orgSlug = this.extractOrgSlugFromUrl(newReportDomain || this.organization_url);

        this.url_os = `https://relatorio.checkmotors.net/${orgSlug}/servico/${this.service_order.hash}?tmp_token=${response.data.token}`;
        return;
      }

      let url = `/${this.getReportPathPrefix()}/${this.service_order.hash}`;
      if (this.organization_url?.includes('site.checkmotors.net')) {
        const arrayUrl = this.organization_url?.split('/');
        url = `/${arrayUrl[arrayUrl.length - 1]}/${this.getReportPathPrefix()}/${this.service_order.hash}`;
      }

      const response = await UserTempTokenService.create({
        user_id: this.user_logged.id,
        url
      });

      this.url_os = `${this.organization_url}/${this.getReportPathPrefix()}/${this.service_order.hash}?tmp_token=${response.data.token}`;
    },
    determineFontSize(name) {
      if (name.length > 50) {
        return {
          fontSize: '24px',
        }
      } if (name.length > 23) {
        return {
          fontSize: '28px',
        }
      }
      return {
        fontSize: '36px',
      }
    },
    showToClientModal() {
      this.dialog_to_client.open = true;
    },
    formatPhone(phone) {
      if (!phone) {
        return false;
      }
      const number = phone.replace(/\D/g, "");

      if (number.length === 10) {
        this.formattedPhoneNumber = `(${number.substring(0, 2)}) ${number.substring(
          2,
          6
        )}-${number.substring(6)}`;
      } else if (number.length === 11) {
        this.formattedPhoneNumber = `(${number.substring(0, 2)}) ${number[2]} ${number.substring(
          3,
          7
        )}-${number.substring(7)}`;
      } else {
        this.formattedPhoneNumber = "";
      }

      return this.formattedPhoneNumber;
    },
    selectConfirmCodeType(type) {
      const self = this;

      self.dialog_confirm_code.open = true;
      self.dialog_confirm_code.code = null;
      self.dialog_confirm_code.type_notification = type;

      self.$http
        .post(`/service_order/${self.service_order.id}/signatures/confirmation/send`, {
          confirmation_method: type,
          signature_hash: self.signature_hash,
        });
    },
    logViewTerm(action, termId = null) {
      const self = this;
      self.$http
        .post(`/signature-log`, {
          service_order_id: self.service_order.id,
          signature_hash: self.signature_hash,
          term_id: termId,
          action,
        });
    },
  },
  watch: {
    'dialog_change_signature_image.open': function onDialogChangeSignatureImageOpen(newVal) {
      if (newVal) {
        this.dialog_change_signature_image.pad = false;

        this.signaturePadTimer = setTimeout(() => {
          if (!this.dialog_change_signature_image.open) return;
          this.dialog_change_signature_image.pad = true;

          this.$nextTick(() => {
            this.signaturePadResizeTimer = setTimeout(() => {
              if (
                this.dialog_change_signature_image.open &&
                this.$refs.signaturePad &&
                this.$refs.signaturePad.$refs &&
                this.$refs.signaturePad.$refs.signaturePadCanvas &&
                this.$refs.signaturePad.resizeCanvas
              ) {
                this.$refs.signaturePad.resizeCanvas();
              }
            }, 100);
          });
        }, 600);
      } else {
        if (this.signaturePadTimer) {
          clearTimeout(this.signaturePadTimer);
          this.signaturePadTimer = null;
        }
        if (this.signaturePadResizeTimer) {
          clearTimeout(this.signaturePadResizeTimer);
          this.signaturePadResizeTimer = null;
        }
        this.dialog_change_signature_image.pad = false;
      }
    },
    signing_method: {
      handler(method) {
        if (method === 'link') {
          this.all_steps = 3;
        } else {
          this.all_steps = 4 + this.selected_signature_type.length;
        }
      }
    },
    signing_type: {
      handler(type) {
        this.selected_signature_type = [];
        if (type === 'company') {
          this.signing_name = this.$store.getters['Auth/user']?.name;
        } else {
          this.signing_name = this.service_order.client ? this.service_order.client.name : null;
          this.signing_email = this.service_order.client ? this.service_order.client.email : null;
        }
      }
    },
    tab: {
      handler(index) {
        this.scrollToTop();

        if (index === 0) {
          this.selected_signature_type = [];
          this.all_steps = 3;
          return;
        }

        if (index === 1 && this.signing_method !== 'link') {
          this.all_steps = 4 + this.selected_signature_type.length;
          return;
        }

        if (this.signing_method !== 'link' && index === 2) {
          this.loading_generating_signature = true;

          setTimeout(() => {
            if (!this.signature_hash) {
              this.saveSignature();
            }
          }, 150);

          return;
        }

        if (this.signing_method !== 'link') {
          const termIndex = index - 3;
          const term = this.selected_signature_type[termIndex];

          if (term) {
            this.logViewTerm('view_term', term.id);
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.dialog-signature {
  .header {
    position: fixed;
    width: 100%;
    z-index: 99;
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .close {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }

  .signature-stepper-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 10px 20px;
    width: -webkit-fill-available;
    background-color: #FFF;
    border-top: 3px solid #3e515f;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 999;

    &.step-counter {
      flex: 1;
      text-align: center;
      font-weight: bold;
    }
  }

  .signature-types {
    margin-top: 20px;
    margin-bottom: 20px;

    .signature-type {
      border: 2px solid #eee;
      border-left: 5px solid #eee;
      overflow: hidden;
      margin-top: 15px;
      border-radius: 6px;

      &.selected {
        border-left: 5px solid #48b38b !important;
      }

      .st-title {
        font-size: 20px;
        padding: 10px;
        border-bottom: 2px solid #eee;
        text-transform: uppercase;
      }

      .st-description {
        padding: 10px;
      }
    }
  }

  .selected-signature {
    margin-top: 100px;
    padding: 10px 20px 0px 20px;
    padding-bottom: 284px;

    .selected-signature-title {
      font-size: 25px;
      font-weight: bold;
      border-bottom: 1px solid #eee;
      padding-bottom: 6px;
      margin-bottom: 10px;
    }
  }

  .signature-table {
    width: 100%;
    border: 1px solid #bebebe;
    font-size: 14px;
    text-transform: uppercase;
    border-radius: 4px;
    text-align: center;

    tr {
      td {
        border-radius: 4px;
        padding: 5px;
        border: 1px solid #d9d9d9;
      }
    }
  }

  .text-loading {
    overflow: hidden;
    padding: 20px 20px 0px 20px;
    margin-top: 100px;
    color: rgba(0, 0, 0, 0.5) !important;

    .text {
      font-size: 32px;
      font-weight: bold;
      position: relative;
      transition: all 1s ease-in-out;
      line-height: 40px;
      margin-bottom: 20px;
    }
  }

  .signature-area {
    text-align: center;
    width: 100%;
    line-height: 30px;
    max-width: 400px;
    margin: 0 auto;
    border: 2px solid #eee;
    border-radius: 6px;
    padding: 12px 0px;

    .signature {
      font-family: 'Dancing Script', cursive !important;
      padding: 10px 0px;
    }

    small {
      font-size: 15px;
    }
  }
}

.signature-pad {
  width: 100%;
  padding: 18px 0 26px 0;
  background-color: #eee;

  .signature-sms {
    height: 172px;
    margin: 10px;
    padding: 10px;
    border: 2px solid #898989;
    border-radius: 4px;
  }

  .pad-content {
    margin: 10px;
    height: 200px;
    border: 2px dashed #898989;
  }

  .pad-bottom {
    padding: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: normal;
    align-content: normal;
  }
}
</style>
